import { render, staticRenderFns } from "./inspect.vue?vue&type=template&id=50749020&scoped=true"
import script from "./inspect.vue?vue&type=script&lang=ts"
export * from "./inspect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50749020",
  null
  
)

export default component.exports